import useOpenTask from "./useOpenTask";
import useIsInappWebview from "./useIsInappWebview";
import useGetDeviceInfo from "./useGetDeviceInfo";
import { compareVersions } from "../logic/logics_common";
import { sendMessage } from "../utils/webview";

export default function useOpenPlanUpgrade(isFromHome?: { isFromHome: boolean }) {
  const openPlanUpgrade = useOpenTask({
    taskKey: `plan-upgrade`,
    params: isFromHome?.isFromHome ? { from: "home" } : undefined,
  });

  const isInappWebview = useIsInappWebview();
  const { appVersion } = useGetDeviceInfo();

  return () => {
    if (isInappWebview && compareVersions(appVersion, "1.1.44") >= 0) {
      sendMessage(
        JSON.stringify({
          event: "open_screen",
          params: {
            url: `${window.location.origin}/plan-upgrade${isFromHome?.isFromHome ? `?from=home` : ``}`,
            type: "card",
            gestureEnabled: true,
            animation: "default",
            replace: false,
          },
        })
      );
      return;
    }

    if (isInappWebview) {
      sendMessage(
        JSON.stringify({
          event: "open_modal",
          params: {
            url: `${window.location.origin}/plan-upgrade${isFromHome?.isFromHome ? `?from=home` : ``}`,
            type: "transparentModal",
          },
        })
      );
    } else {
      openPlanUpgrade();
    }
  };
}
